module.exports = __webpack_public_path__ + "img/icon_dy.7bcbe677.jpg";